import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUser, LoginResponse } from '../../../types/auth.types';
import { setHeaderConfigAxios } from '../../api/axios';
import { IS_WEB } from '../../../constants/platform';
import { messaging } from '../../../services/firebase-message';

export type AuthState = {
  access_token?: string;
  loggedin: boolean;
  user?: IUser;
  fcmToken?: string;
  role?: 'Individual' | 'Corporate' | 'Instructor' | 'Volunteer';
  unreadMessage?: number;
};

const initialState: AuthState = {
  loggedin: false,
  unreadMessage: 0,
};

//const initialUserState: Partial<IUser> = {};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setCredential: (state, action: PayloadAction<any>) => {
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
      state.role = action.payload.user.type_name;
      state.loggedin = true;
    },
    setUserInfo: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.role = action.payload.type_name;
    },
    logout: (state, action: PayloadAction) => {
      setHeaderConfigAxios();
      if (!IS_WEB) {
        messaging()
          .unsubscribeFromTopic('notices')
          .then(() => console.log('Unsubscribed from the topic notices!'));
      }
      state.user = undefined;
      state.access_token = undefined;
      state.loggedin = false;
      state.role = undefined;
    },
    setFcmToken: (state, action: PayloadAction<string>) => {
      state.fcmToken = action.payload;
    },
    setUnreadMessage: (state, action: PayloadAction<number>) => {
      state.unreadMessage = action.payload;
    },
  },
});

export const {
  setCredential,
  logout,
  setUserInfo,
  setFcmToken,
  setUnreadMessage,
} = authSlice.actions;
export default authSlice.reducer;
